import React, { useState } from "react";
import FilterComponent from "../Layout/FilterComponent";
import SearchExportComponent from "../Layout/SearchExportComponent";
import TableLayout from "../Layout/TableLayout";
import Pagination from "../Layout/Pagination";
import DetailBox from "./DetailBox";

const VisitOverview = ({
  data,
  currentPage,
  totalPages,
  totalCount,
  setCurrentPage,
  setSearchTerm,
  itemsPerPage,
  setItemsPerPage,
}) => {
  const [openDetailBox, setOpenDetailBox] = useState(false);
  const [selectedObject, setSelectedObject] = useState([]);
  const [visibleHeaders, setVisibleHeaders] = useState([
    "Name",
    "doctorsname",
    "products",
    "note",
    "action",
  ]);
  const tableHeaders = [
    { label: "Date", value: "Name" },
    { label: "Doctor name", value: "doctorsname" },
    { label: "Products", value: "products" },
    { label: "Note", value: "note" },
    { label: "Distributor", value: "distributor_name" },
    { label: "Patient Email", value: "patientemail" },
    { label: "Group Name", value: "group_title" },
    { label: "Product Group", value: "product_group" },
    { label: "Category", value: "category" },
    { label: "UnitPrice", value: "unit_price" },
    { label: "Quantity", value: "quantity" },
    { label: "Value", value: "value" },
    { label: "Status", value: "tracking_status" },
    { label: "Sales Order_Status", value: "sales_order_status" },
    { label: "Action", value: "action" },
  ];

  const handleSearch = (term) => setSearchTerm(term);
  const handleItemsPerPageChange = (newItemsPerPage) => {
    setItemsPerPage(newItemsPerPage);
    setCurrentPage(1);
  };
  const handlePageChange = (page) => setCurrentPage(page);
  const handleExport = () => console.log("Exporting data:", data);

  const handleViewAction = (item) => {
    console.log("view");
    console.log("item", item);
    setSelectedObject(item);
    setOpenDetailBox(true);
  };

  return (
    <div className="px-0 sm:px-4">
      <SearchExportComponent
        exportFileName="Visit"
        onSearch={handleSearch}
        onExport={handleExport}
        // searchPlaceholder="Search"
        tablefields={tableHeaders}
        selectedHeaders={visibleHeaders}
        onHeadersChange={setVisibleHeaders}
        FilterOptionVisisbility={false}
        exportData={data} //FIXME:
      />
      <TableLayout
        data={data}
        headers={tableHeaders.filter((header) =>
          visibleHeaders.includes(header.value)
        )}
        handleAction={handleViewAction}
      />
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        totalCount={totalCount}
        onPageChange={handlePageChange}
        itemsPerPage={itemsPerPage}
        onItemsPerPageChange={handleItemsPerPageChange}
      />
      {openDetailBox && (
        <DetailBox
          handleClose={() => setOpenDetailBox(false)}
          selectedObject={selectedObject}
        />
      )}
    </div>
  );
};

export default VisitOverview;
